"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SOCKET_BROADCAST_EVENTS = void 0;
const events_1 = require("../../enums/external/events");
exports.SOCKET_BROADCAST_EVENTS = [
    events_1.SocketEvent.EDIT,
    events_1.SocketEvent.NEW,
    events_1.SocketEvent.TYPING,
    events_1.SocketEvent.JOINED,
    events_1.SocketEvent.REMOVE,
    events_1.SocketEvent.STOP_TYPING,
];
